import { Button } from 'components/Button/Button';
import { Modal } from 'components/Modal/Modal';
import { useTranslation } from 'react-i18next';

type ConfirmInvoicePaidModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    invoice: any;
};

export const ConfirmInvoicePaidModal: React.FC<ConfirmInvoicePaidModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    invoice,
}) => {
    const { t } = useTranslation('documents');

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="space-y-4">
                <h3 className="text-lg font-semibold">{t('confirmMarkAsPaidTitle')}</h3>
                <p className="text-sm text-zinc-600">
                    {t('confirmMarkAsPaidMessage', { invoiceId: invoice?.invoiceId })}
                </p>
                <div className="flex justify-end gap-2">
                    <Button variant="outline" onClick={onClose}>
                        {t('cancelButton')}
                    </Button>
                    <Button onClick={onConfirm}>{t('confirmButton')}</Button>
                </div>
            </div>
        </Modal>
    );
};
